import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { Link } from 'react-router';
import { darken, rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexRowCenter,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { TableRow, TableTd } from '../General/Table';
import { DsiSvgIcon as SvgIcon, Modal } from '../../..';
import { IconType } from '../General/SvgIcon';
import { Button } from '../../Zemplin/General/Button';
import { CountSetter } from '../Product/CountSetter';
import { useState } from 'react';
import {
  getCartItemInfo,
  getProductDetailInfo,
} from '../../../utilities/selectors';
import { formatPrice, formatPriceToString, prop } from '../../../utilities';
import { isNumeric, isPositiveNumeric } from './utilities';
import { getImagePath } from '../../../utilities/product';
import { __ } from 'react-i18n';
import { DsiGiftChooserModalContent } from './GiftChooserModalContent';
import { PlusIconWrapper } from './ProductCartTableSaleRow';

export interface Props {
  item?: any;
  theme: any;
  updateCart: any;
  addToCart: any;
  removeFromCart: any;
  isB2B?: boolean;
  availableGifts?: any[];
  originalItem?: any;
  itemIndex?: number;
  showRemove?: boolean;
}

function ProductCartTableActionSaleRow(props: Props) {
  const {
    item,
    addToCart,
    removeFromCart,
    updateCart,
    isB2B,
    theme,
    availableGifts,
    originalItem,
    itemIndex,
    showRemove,
  } = props;

  const {
    ordernr,
    name,
    image,
    productUrl,
    units: unit,
    availability,
    availId,
    productId,
    goodId,
    saleQuantity,
    finalPrice,
    finalPriceWithoutVat,
    finalSalePrice,
    finalSalePriceWithoutVat,
    totalSalePrice,
    totalSalePriceWithoutVat,
    currencyId,
    totalPrice,
    totalPriceWithoutVat,
  } = getCartItemInfo(item);

  const handleRemoveClick = () => {
    removeFromCart(productId, goodId);
  };

  const quantity = saleQuantity || 1;

  return (
    <>
      <StyledTableRow>
        <PlusIconWrapper>
          <SvgIcon
            fill={'white'}
            icon={IconType.plus}
            viewBox={'0 0 8 8'}
            width={12}
            height={12}
          />
        </PlusIconWrapper>
        <ImageNameTableTd>
          <StyledLink to={productUrl}>
            <Image
              alt={`Obrázok ku produktu ${name ? name : ''}`}
              src={image}
            />
          </StyledLink>
          <StyledLink to={productUrl}>
            <NameInputWrapper>
              <Name>{name}</Name>
              <Plu>{`${ordernr}`}</Plu>
              <Availability availId={availId}>{`${availability}`}</Availability>
            </NameInputWrapper>
          </StyledLink>
        </ImageNameTableTd>
        <StyledTableTd align={'right'}>
          <CellText fontWeight={500}>
            <PriceWrapper>
              <OldPrice>
                {formatPrice(
                  isB2B ? finalPriceWithoutVat : finalPrice,
                  currencyId,
                  2,
                  false,
                  '',
                  false,
                )}
              </OldPrice>
              <Price>
                {formatPrice(
                  isB2B ? finalSalePriceWithoutVat : finalSalePrice,
                  currencyId,
                  2,
                  false,
                  '',
                  false,
                )}
              </Price>
            </PriceWrapper>
          </CellText>
        </StyledTableTd>
        <StyledTableTd align={'center'}>
          <FlexRowCenterVertical>
            <CountText marginLeft={16}>{`${quantity} ${unit}`}</CountText>
          </FlexRowCenterVertical>
        </StyledTableTd>
        <StyledTableTd align={'right'}>
          <CellText fontWeight={500}>
            <PriceWrapper>
              <OldPrice>
                {formatPrice(
                  isB2B
                    ? finalPriceWithoutVat * quantity
                    : finalPrice * quantity,
                  currencyId,
                  2,
                  false,
                  '',
                  false,
                )}
              </OldPrice>
              <Price>
                {formatPrice(
                  isB2B ? totalSalePriceWithoutVat : totalSalePrice,
                  currencyId,
                  2,
                  false,
                  '',
                  false,
                )}
              </Price>
            </PriceWrapper>
          </CellText>
        </StyledTableTd>
        <StyledIconTableTd align={'center'}>
          {showRemove ? (
            <StyledButton onClick={handleRemoveClick}>
              <SvgIcon
                cursor={'pointer'}
                icon={IconType.trash}
                width={24}
                height={24}
                fill={'#000000'}
              />
            </StyledButton>
          ) : (
            <SvgIcon
              icon={IconType.percentage}
              width={24}
              height={24}
              fill={theme.colors.primary}
              title={__('Akcia')}
            />
          )}
        </StyledIconTableTd>
      </StyledTableRow>
    </>
  );
}

const StyledTableTd = styled(TableTd)<{ align?: string }>`
  text-align: ${({ align }) => (align ? align : 'left')};
  padding: ${rem(18)} ${rem(16)};
  width: 100%;
`;

const StyledIconTableTd = styled(StyledTableTd)``;

const ChangeGiftTableTd = styled(StyledTableTd)`
  ${({ theme }) => theme.mediab.m810`
     width: unset;
     padding-right: 0;
     padding-left: ${rem(12)};
  `}
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border: 0;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: ${rem(4)};
  position: relative;
`;

const StyledChooseTableRow = styled(StyledTableRow)``;

const CellText = styled(TextP)<{ fontWeight: number; marginLeft?: number }>`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '400')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ theme }) => theme.mediab.m810`
     font-size: ${rem(14)};
  `}
`;

const ChangeGiftButton = styled.button`
  color: ${({ theme }) => theme.colors.primary};
  background: none;
  border: 0;
  display: flex;
  flex-flow: row;
  align-items: center;

  &:hover {
    opacity: 0.8;
    transition: opacity 0.2s ease-in-out;
  }

  ${({ theme }) => theme.mediab.m810`
      display: flex;
      justify-content: center;
      flex-flow: column;
      padding: 0;
  `}
`;

const ChangeGiftText = styled(CellText)<{ fontSize?: string }>`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: ${({ fontSize }) =>
    fontSize === 'large' ? 'none' : 'underline'};
  background: none;
  font-size: ${({ fontSize }) => (fontSize === 'large' ? rem(20) : rem(14))};
  cursor: pointer;
  font-family: ${({ theme }) => theme.font.tertiary};

  ${({ theme }) => theme.mediab.m810`
     font-size: ${rem(14)};
  `}
`;

const CountText = styled(TextP)<{ marginLeft?: number }>`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-left: ${({ marginLeft }) => (marginLeft ? rem(marginLeft) : 0)};
  white-space: nowrap;

  ${({ theme }) => theme.mediab.m810`
     font-size: ${rem(14)};
  `}
`;

const ImageNameTableTd = styled(StyledTableTd)`
  display: flex;
  align-items: center;
  max-width: ${rem(300)};
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Image = styled.img`
  width: ${rem(56)};
  max-width: ${rem(56)};
  height: ${rem(56)};
  /* max-width: initial; */
  margin-right: ${rem(16)};
`;

const NameInputWrapper = styled(FlexCol)`
  max-width: ${rem(400)};

  ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(200)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(180)};
  `}

  ${({ theme }) => theme.mediab.l1050`
      max-width: ${rem(130)};
  `}

  ${({ theme }) => theme.mediab.l925`
      max-width: ${rem(200)};
  `}
`;

const Name = styled(TextP)`
  font-size: ${rem(16)};
  margin-bottom: ${rem(4)};
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: left;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  /* max-width: ${rem(400)}; */
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }

  /* ${({ theme }) => theme.mediab.l1300`
      max-width: ${rem(300)};
  `}

  ${({ theme }) => theme.mediab.l1150`
      max-width: ${rem(200)};
  `} */
`;

const Plu = styled(TextP)`
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  color: ${({ theme }) => theme.colors.placeholder};
  text-align: left;
  font-family: ${({ theme }) => theme.font.tertiary};
  font-weight: 300;
`;

const StyledButton = styled(Button)`
  width: ${rem(56)};
  height: ${rem(56)};
  background-color: ${({ theme }) => theme.colors.white};
  border: 2px solid rgba(30, 57, 141, 1);
  border-radius: 4px;
  opacity: 0.08;
  padding: 0;
`;

const Availability = styled(TextP)<{ availId: number }>`
  font-size: ${rem(16)};
  color: ${({ theme, availId }) =>
    availId === 1 ? theme.colors.successColor : theme.colors.dangerColor};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const OldPrice = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  color: #ff1e45eb;
  text-decoration: line-through;
  letter-spacing: 0;
  font-weight: 400;

  ${({ theme }) => theme.mediab.l1050`
  `}
`;

const Price = styled(TextP)``;

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const WithThemeRow: any = withTheme(ProductCartTableActionSaleRow);
export { WithThemeRow as DsiProductCartTableActionSaleRow };
